import React, { useContext, useEffect } from 'react'
import { Redirect } from 'react-router'
import { AuthContext } from '../../contexts/AuthContext'

const LogoutPage: React.FC = () => {
  const { handleLogout } = useContext(AuthContext)

  useEffect(() => {
    handleLogout()
  }, [handleLogout])

  return <Redirect to="/login" />
}

export default LogoutPage
